import { toRefs, computed } from 'vue'

/**
 * @description Props khi dùng label
 * @author PHNam
 */
const label = {
  props: {
    // Nội dung label
    label: {
      type: String,
      default: ''
    },

    // Căn label về phía nào
    labelAlign: {
      type: String,
      default: 'left',
      validator: (value) => {
        return ['top', 'left', 'right'].indexOf(value) > -1
      }
    },

    // min-width của label
    labelMinWidth: {
      type: [String, Number],
      default: 'max-content'
    },

    // class custom
    customClass: {
      type: String,
      default: null
    }
  }
}

/**
 * @description Utility Sử dụng label cho field như text-field, combo, ...
 * @param {*} props
 * @returns
 * @author PHNam
 */
const useLabel = function (props) {
  const { label, labelAlign, labelMinWidth: lblMinWidth } = toRefs(props)
  const hasLabel = !!label.value
  const labelCls = computed(() => ({
    'has-label': hasLabel,
    [`align-${labelAlign.value}`]: hasLabel

  }))
  const labelStyles = computed(() => ({
    'min-width': lblMinWidth?.value
  }))

  return { labelCls, labelStyles }
}

export { label, useLabel }
